module.exports = __webpack_public_path__ + "static/media/readMessage.c2930cfb.svg";